import React, {Component} from 'react';
import PrintPreview from '../PrintPreview'
import ReportStore from 'stores/ReportStore'
import './Print.css';

const DEFAULT_ROW = 41
class PrintReportProductBalance extends Component {

    constructor(...args) {
        super(...args)
            
        this.state = {loading:false,dataList:[],data:[],report_title:'กำลังดึงข้อมูล..'}

        var cssPagedMedia = (function() {
            var style = document.createElement('style');
            document.head.appendChild(style);
            return function (rule) {
            style.innerHTML = rule;
            };
        }());
    
        cssPagedMedia.size = function(size) {
            cssPagedMedia('@page {size: ' + size + '}');
        };
        cssPagedMedia.size('portrait');
    }

    componentDidMount() {
        this.loadData()
    }

    loadData() {
        if (this.props.isRange=='false'&&this.props.year!=undefined&&this.props.month!=undefined&&this.props.day!=undefined&&this.props.groupId!=undefined) {
            ReportStore.loadReportProductBalance(this.props.year,this.props.month,this.props.day,this.props.groupId,(result)=>{
                this.setState({data:result.data,dataList:this.getPagination(result.data),report_title:'ไม่พบข้อมูล'})
            },()=>{

            })   
        } else if (this.props.isRange=='true'&&this.props.startDate!=undefined&&this.props.endDate!=undefined&&this.props.groupId!=undefined) {
            ReportStore.loadReportProductBalanceRange(this.props.startDate,this.props.endDate,this.props.groupId,(result)=>{
                this.setState({data:result.data,dataList:this.getPagination(result.data),report_title:'ไม่พบข้อมูล'})
            },()=>{
                
            })
        } else {
            this.setState({data:[],dataList:this.getPagination([]),report_title:'ไม่พบข้อมูล'})
        }
    }

    getNumberFormat(value,digit=2) {
        let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
        _val = parseFloat(_val)
        return _val.toFixed(digit).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
    }
    
    getSummary(field) {
        let {data} = this.state
        let total = 0
        data.forEach((item,index)=> {
            total += (item[field]===''||item[field]===null||item[field]===undefined||isNaN(item[field])?0:item[field]*1)
        }) 
        return total
    }

    getPagination(data) {
        let newData = []
        let allData = []
        let checkRow = 0
        data.forEach(function(item,index) {
            if (checkRow<DEFAULT_ROW)
              checkRow++
              newData.push(item)
    
            if (checkRow===DEFAULT_ROW-1||index===data.length-1) {
              allData.push(newData)
              checkRow = 0
              newData = []
            }
        })  
        
        return allData
    }

    renderRowData(data,indexs) {
        let {groupId} = this.props
        if (data.length==0) {
            return(<tr><td colSpan={12}>ไม่พบข้อมูล</td></tr>)
        } else {
            return data.map((item, index) => (
                <tr key={index}>
                <td className='text-center'>{(indexs*40)+index+1}</td>
                <td className='text-center'>{item.productcode}</td>
                <td className='text-left'>{item.description}</td>
                <td className='text-center'>{groupId=='tool'?'เครื่องมือช่าง':groupId=='genpart'?'อะไหล่(ทั่วไป)':groupId=='officemate'?'เบ็ตเตล็ด':'สีรถยนต์'}</td>
                <td className='text-center'>{item.location}</td>
                <td className='text-center'>{item.in_quantity}</td>
                <td className='text-center'>{item.out_quantity}</td>
                <td className='text-center'>{item.balance_quantity}</td>
                <td className='text-center'>{item.unit}</td>
                <td className='text-right'>{this.getNumberFormat(item.cost_per_unit)}</td>
                <td className='text-right'>{this.getNumberFormat(item.price_per_unit)}</td>
                <td className='text-left'>{item.remark}</td>
                </tr>
            ))
        }
    }

    renderTable(item,index,length) {
        return(
            <table className='table table-print-report-product-balance'>
                <tbody>
                    <tr>
                        <td rowSpan={2} className='text-center' style={{width:'50px'}}>ลำดับ</td>
                        <td rowSpan={2} className='text-center' style={{width:'100px'}}>รหัสสินค้า</td>
                        <td rowSpan={2} className='text-center' style={{width:'350px'}}>ชื่ออะไหล่</td>
                        <td rowSpan={2} className='text-center' style={{width:'90px'}}>ประเภท</td>
                        <td rowSpan={2} className='text-center' style={{width:'80px'}}>ชั้นวาง</td>
                        <td colSpan={3} className='text-center'>จำนวน</td>
                        <td rowSpan={2} className='text-center' style={{width:'80px'}}>หน่วย</td>
                        <td colSpan={2} className='text-center'>ราคา</td>
                        <td rowSpan={2} className='text-center' style={{width:'100px'}}>หมายเหตุ</td>
                    </tr>
                    <tr>
                        <td className='text-center' style={{width:'50px'}}>เข้า</td>
                        <td className='text-center' style={{width:'50px'}}>ออก</td>
                        <td className='text-center' style={{width:'80px'}}>คงเหลือ</td>
                        <td className='text-center' style={{width:'90px'}}>ต้นทุน</td>
                        <td className='text-center' style={{width:'90px'}}>ราคาขาย</td>
                    </tr>
                    {this.renderRowData(item,index)}
                    {length-1===index?
                    <tr>
                        <td colSpan={5} className='text-right'>ยอดรวมสุทธิ</td>
                        <td className='text-center'>{this.getNumberFormat(this.getSummary('in_quantity'),0)}</td>
                        <td className='text-center'>{this.getNumberFormat(this.getSummary('out_quantity'),0)}</td>
                        <td className='text-center'>{this.getNumberFormat(this.getSummary('balance_quantity'),0)}</td>
                        <td className='text-right'></td>
                        <td className='text-right'>{this.getNumberFormat(this.getSummary('cost_per_unit'))}</td>
                        <td className='text-right'>{this.getNumberFormat(this.getSummary('price_per_unit'))}</td>
                        <td className='text-right'></td>
                    </tr> 
                    :''}   
                </tbody>
            </table>
        )
    }

    renderComponentPage(item,index,length) {
        return(  
            <div className='font-print' key={index}>
                <header className="text-center">
                    <h2>{this.props.title}</h2>
                </header>
                <div>
                    {this.renderTable(item,index,length)}
                </div>
            </div>
        )    
    }
    
    renderNoData() {
        return(
          <div className='font-print'>
            <header className="text-center">
                <h2>{this.state.report_title}</h2>
            </header>
          </div>
        )
    }

    render() {
        let {loading,dataList} = this.state
        if (dataList.length==0) {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.title}
                >
                    {this.renderNoData()}    
                </PrintPreview>
            )
        } else {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.title}
                >
                    {
                        dataList.map((item,index)=>{
                            return(
                                this.renderComponentPage(item,index,dataList.length)
                            )
                        })   
                    }
                </PrintPreview>
            )
        }      
    }
}

PrintReportProductBalance.defaultProps = {
    title: 'ตารางรายงานปรับสต็อก',  
    mode : '',
    workNo : ''
  }
  export default PrintReportProductBalance;


// WEBPACK FOOTER //
// ./src/view/print/stock/PrintReportProductBalance.js